import { render, staticRenderFns } from "./RegisterNewsletter.vue?vue&type=template&id=a0dd0b58&scoped=true&"
import script from "./RegisterNewsletter.vue?vue&type=script&lang=js&"
export * from "./RegisterNewsletter.vue?vue&type=script&lang=js&"
import style0 from "./RegisterNewsletter.vue?vue&type=style&index=0&id=a0dd0b58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0dd0b58",
  null
  
)

export default component.exports